import { FC } from "react";
import { Box, Container } from "@mui/material";
import GitInfo from "react-git-info/macro";
import { useCustomThemeContext } from "../../../providers/customThemeProvider";

// Define the Footer functional component
const Footer: FC = () => {
  // Get the theme from the custom theme context
  const { theme } = useCustomThemeContext();

  // Get the git information using the GitInfo macro
  const gitInfo = GitInfo();

  // Format the commit date
  const commitDate = new Date(gitInfo.commit.date);
  const formattedDate = `${commitDate.getDate().toString().padStart(2, "0")}/${(
    commitDate.getMonth() + 1
  )
    .toString()
    .padStart(2, "0")}/${commitDate.getFullYear()}`;

  return (
    <Container
      disableGutters
      maxWidth={false}
      data-testid="footerContainer"
      sx={{
        width: "100%", // Set the width to 100%
        mt: "auto", // Set the margin top to auto
        backgroundColor: theme.palette.navbarColor.main, // Set the background color from the theme
        borderTop: 5, // Set the top border width
        borderColor: theme.palette.primary.main, // Set the border color from the theme
        position: "relative",
      }}
    >
      <Box
        className="footer-content"
        display="flex"
        flexDirection={"column"}
        justifyContent="center"
        alignItems="center"
        padding={"1rem"}
      >
        {/* Display the copyright text */}
        <p data-testid="copyright" style={{ padding: "0", margin: "0" }}>
          &copy; {new Date().getFullYear()} Re-Evented. All rights reserved.
        </p>
        {/* Display the version and commit info */}
        <p data-testid="version" style={{ padding: "0", margin: "0" }}>
          Version: {gitInfo.commit.shortHash} ({formattedDate})
        </p>
      </Box>
    </Container>
  );
};

export default Footer;
